import { PageBlueprint, createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';

const WEBSITE_ANNOTATION = 'overheid.nl/website-url';
const FORGEJO_ANNOTATION = 'code.overheid.nl/project-slug';

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/',
    title: 'Home',
    noHeader: true,
    loader: () => import('./HomePage').then(module => <module.HomePage />),
  },
});

const registersPage = PageBlueprint.make({
  name: 'registers',
  params: {
    path: '/registers',
    title: 'Registers',
    noHeader: true,
    loader: () =>
      import('./RegistersPage').then(module => <module.RegistersPage />),
  },
});

const toegankelijkheidPage = PageBlueprint.make({
  name: 'toegankelijkheid',
  params: {
    path: '/toegankelijkheid',
    title: 'Toegankelijkheid',
    noHeader: true,
    loader: () =>
      import('./LoepPages').then(module => <module.ToegankelijkheidPage />),
  },
});

const kennisbankPage = PageBlueprint.make({
  name: 'kennisbank',
  params: {
    path: '/kennisbank',
    title: 'Kennisbank',
    noHeader: true,
    loader: () => import('./KennisbankPage').then(module => <module.KennisbankPage />),
  },
});

const techRadarPage = PageBlueprint.make({
  name: 'techradar',
  params: {
    path: '/kennisbank/techradar',
    title: 'Tech Radar',
    noHeader: true,
    loader: () => import('./TechRadarPage').then(module => <module.TechRadarPage />),
  },
});

const inzichtPage = PageBlueprint.make({
  name: 'inzicht',
  params: {
    path: '/inzicht',
    title: 'Inzicht',
    noHeader: true,
    loader: () => import('./InzichtPages').then(module => <module.InzichtPage />),
  },
});

const beveiligingPage = PageBlueprint.make({
  name: 'beveiliging',
  params: {
    path: '/inzicht/beveiliging',
    title: 'Wie is geraakt?',
    noHeader: true,
    loader: () => import('./InzichtPages').then(module => <module.BeveiligingPage />),
  },
});

const designSystemPage = PageBlueprint.make({
  name: 'designsysteem',
  params: {
    path: '/inzicht/designsysteem',
    title: 'Designsysteem',
    noHeader: true,
    loader: () => import('./InzichtPages').then(module => <module.DesignSystemPage />),
  },
});

const settingsPage = PageBlueprint.make({
  name: 'settings',
  params: {
    path: '/settings',
    title: 'Instellingen',
    noHeader: true,
    loader: () => import('./SettingsPage').then(module => <module.SettingsPage />),
  },
});

const mijnOpencodePage = PageBlueprint.make({
  name: 'mijn-opencode',
  params: {
    path: '/mijn-opencode',
    title: 'Mijn opencode',
    noHeader: true,
    loader: () => import('./MijnOpencodePage').then(module => <module.MijnOpencodePage />),
  },
});

const entityHercontrole = EntityContentBlueprint.make({
  name: 'hercontrole',
  params: {
    path: '/hercontrole',
    title: 'Hercontrole',
    filter: (entity: Entity) => entity.kind === 'Group' && entity.spec?.type === 'team',
    loader: () => import('./TeamReviewPage').then(module => <module.EntityHercontrole />),
  },
});

const entityToegankelijkheid = EntityContentBlueprint.make({
  name: 'toegankelijkheid',
  params: {
    path: '/toegankelijkheid',
    title: 'Toegankelijkheid',
    filter: (entity: Entity) =>
      Boolean(entity.metadata.annotations?.[WEBSITE_ANNOTATION]),
    loader: () =>
      import('./LoepPages').then(module => <module.EntityToegankelijkheid />),
  },
});

const entityOntwikkeling = EntityContentBlueprint.make({
  name: 'ontwikkeling',
  params: {
    path: '/ontwikkeling',
    title: 'Ontwikkeling',
    filter: (entity: Entity) =>
      Boolean(entity.metadata.annotations?.[FORGEJO_ANNOTATION]),
    loader: () =>
      import('./OntwikkelingPage').then(module => <module.EntityOntwikkeling />),
  },
});

export const portaalPlugin = createFrontendPlugin({
  pluginId: 'portaal',
  extensions: [
    homePage,
    registersPage,
    toegankelijkheidPage,
    techRadarPage,
    kennisbankPage,
    beveiligingPage,
    designSystemPage,
    inzichtPage,
    settingsPage,
    mijnOpencodePage,
    entityToegankelijkheid,
    entityHercontrole,
    entityOntwikkeling,
  ],
});
